module.exports = __webpack_public_path__ + "img/right-arrow-primary.288f5c83.svg";